import { render } from "./CartFoodCard.vue?vue&type=template&id=1d55bcf7"
import script from "./CartFoodCard.vue?vue&type=script&lang=js"
export * from "./CartFoodCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__